export const HERO_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/883b78d4-a70d-49ff-b8f2-0a1a7a40d838.jpg'
export const NUDOS_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/62782b26-5901-4fff-98ed-8ade5a8845a8.jpg'
export const AGUA_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/055a8371-73aa-4ca0-9cc0-19cde7ed3c07.jpg'
export const FUEGO_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/b821a0af-fdc3-494f-bbe5-9226314ff41a.jpg'
export const TIERRA_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/e95db820-a38c-4f7a-a04d-157c1c90b012.jpg'
export const HOTEL_CABANAS_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/985c09bf-0495-49b8-85d3-9814023b25af.jpg'
export const HOTEL_DECK_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/6894789d-70af-4d3f-9b45-a346b0b59a65.jpg'
export const HOTEL_ROOM_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/3c7997e2-0d52-4b40-b4b9-fe804cfb8bf5.jpg'
export const VIRGEN_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/3e8442d7-c508-4598-b4d0-5784c498ae60.jpg'
export const FRECUENCIA_IMG =
  'https://cdn.magicpatterns.com/patterns/generated-images/50bee09c-990b-4b59-abc2-fc9e5e8799c6.jpg'

export const RESERVA_LINK =
  'https://wa.me/34682575310?text=Quiero%20informaci%C3%B3n%20sobre%20el%20retiro%20El%20%C3%9Altimo%20Nudo%20en%20Bacalar'

export const PAGO_LINK = 'https://buy.stripe.com/4gMbJ04QogokgOX1vvbjW05'

export const SEPARACION = '444 USD'

export interface Nudo {
  titulo: string
  texto: string
}

export const NUDOS: Nudo[] = [
  {
    titulo: 'Estancamiento',
    texto: 'Un lugar que parece no tener salida, aunque lo intentes todo.',
  },
  {
    titulo: 'Cansancio',
    texto: 'Ese que el descanso ya no resuelve, porque no es del cuerpo.',
  },
  {
    titulo: 'Miedo',
    texto: 'Disfrazado de "responsabilidad" para que no lo cuestiones.',
  },
  {
    titulo: 'Patrones que se repiten',
    texto: 'Las mismas escenas con personas distintas, una y otra vez.',
  },
]

export interface Elemento {
  emoji: string
  numero: string
  nombre: string
  titulo: string
  puntos: { titulo: string; texto: string }[]
  cita: string
  imagen: string
  acento: string // css color var
}

export const ELEMENTOS: Elemento[] = [
  {
    emoji: '🌊',
    numero: 'El Primer Elemento',
    nombre: 'El Agua',
    titulo: 'Fluir, confiar y entregar',
    puntos: [
      {
        titulo: 'Mandala Acuático · Fluir',
        texto:
          'Movimiento, respiración y conexión grupal en las aguas de la Laguna de los Siete Colores. El agua se vuelve símbolo de confianza y entrega, recibiendo las 7 potencias.',
      },
      {
        titulo: 'Catamarán al Atardecer · Agradecer',
        texto:
          'Navegaremos la laguna mientras cae el sol: un momento de celebración y gratitud por lo vivido y por la oportunidad de estar presentes.',
      },
      {
        titulo: 'Sound Healing · Vibrar',
        texto:
          'Cuencos e instrumentos sonoros conducen el cuerpo hacia la quietud interna — ese lugar donde los nudos comienzan a aflojarse solos.',
      },
    ],
    cita: 'El agua no empuja: rodea, ablanda y desenreda.',
    imagen: AGUA_IMG,
    acento: 'var(--blugreen)',
  },
  {
    emoji: '🔥',
    numero: 'El Segundo Elemento',
    nombre: 'El Fuego',
    titulo: 'Temazcal · El útero',
    puntos: [
      {
        titulo: 'Introspección profunda',
        texto:
          'El calor, el vapor, la oscuridad y los elementos naturales acompañan un espacio de liberación y renovación dentro del vientre de la tierra.',
      },
      {
        titulo: 'Salir diferente',
        texto:
          'No se trata de resistir el calor, sino de permitir que lo que ya no te pertenece se quede adentro. Lo promete la tradición ancestral.',
      },
    ],
    cita: 'Entras cargando; sales liviano.',
    imagen: FUEGO_IMG,
    acento: 'var(--darkgoldenrod)',
  },
  {
    emoji: '🌬🌱',
    numero: 'Tercer y Cuarto Elemento',
    nombre: 'El Aire y la Tierra',
    titulo: 'Enraizar, escuchar y sostener',
    puntos: [
      {
        titulo: 'Yoga y conexión matutina',
        texto:
          'Movimiento consciente y respiración para comenzar las mañanas desde la calma y la presencia.',
      },
      {
        titulo: 'Jardín y Huerto Sintrópico',
        texto:
          'Descubrir cómo la naturaleza encuentra equilibrio cuando cada elemento ocupa su lugar: una hermosa metáfora de nuestros propios procesos.',
      },
      {
        titulo: 'Ritual con la Tierra · Enraizar',
        texto:
          'Sentirnos sostenidos, agradecer, reconocer nuestras raíces y volver plenamente al presente.',
      },
    ],
    cita: 'Cuando cada elemento ocupa su lugar, el equilibrio deja de ser esfuerzo.',
    imagen: TIERRA_IMG,
    acento: 'var(--glossygrape)',
  },
]

export const ASCENDER: { titulo: string; texto: string }[] = [
  {
    titulo: 'Claridad',
    texto:
      'Ver tus patrones desde otro lugar, con más verdad y menos ruido interno.',
  },
  {
    titulo: 'Soltar',
    texto:
      'Entregar lo que hasta hoy no supiste desenredar, resolver ni comprender.',
  },
  {
    titulo: 'Crear',
    texto:
      'Cerrar el año con intención y abrir el próximo sin nudos que te frenen.',
  },
  {
    titulo: 'Sostener',
    texto:
      'Optimizar tu infraestructura energética para que puedas volver y mantenerte.',
  },
]

export const PARA_TI: string[] = [
  'Pediste que se te revelaran verdades… y las revelaciones llegaron. Ahora necesitas un lugar donde sostenerlas.',
  'Sientes que ya no cabes en la versión de ti que venías siendo, aunque todavía no sepas nombrar la siguiente.',
  'Algo dentro de ti sabe que hay más: más potencia, más presencia, más propósito. Y ya no puedes desoírlo.',
  'Estás lista para dejar de gestionar tu vida desde la mente y empezar a crearla desde el alma.',
]

export interface HotelImagen {
  imagen: string
  titulo: string
  texto: string
  alt: string
}

export const HOTEL: HotelImagen[] = [
  {
    imagen: HOTEL_DECK_IMG,
    titulo: 'Decks sobre el agua',
    texto:
      'Hamacas y cojines suspendidos sobre la laguna: tu lugar para no hacer nada y recibirlo todo.',
    alt: 'Deck de madera con hamacas sobre el agua turquesa al amanecer',
  },
  {
    imagen: HOTEL_ROOM_IMG,
    titulo: 'Suites frente a la laguna',
    texto:
      'Madera, lino y ventanales abiertos al agua. Despertar aquí ya es parte del proceso.',
    alt: 'Interior de suite con cama de lino blanco y ventanal frente a la laguna',
  },
]

export interface Detalle {
  emoji: string
  aspecto: string
  detalle: string
}

export const DETALLES: Detalle[] = [
  {
    emoji: '📅',
    aspecto: 'Fechas',
    detalle:
      '26 de noviembre — 1 de diciembre · 6 días / 5 noches (4 noches en Bacalar + 1 noche en Cancún)',
  },
  {
    emoji: '✈️',
    aspecto: 'Punto de encuentro',
    detalle: 'Cancún, Quintana Roo — de ahí viajamos juntos a Bacalar',
  },
  {
    emoji: '🏡',
    aspecto: 'Alojamiento',
    detalle:
      'Akalki, Bacalar (4 noches) — cabañas sobre la Laguna de los Siete Colores · 1 noche en Cancún para el cierre',
  },
  {
    emoji: '🤍',
    aspecto: 'Grupo',
    detalle:
      'Cupo limitado a 15 personas · Encuentro mixto, cada quien a su propio ritmo',
  },
  {
    emoji: '🛕',
    aspecto: 'Experiencias',
    detalle:
      'Yoga, visita al templo, huerto sintrópico, temazcal, mandala acuático, sound healing y catamarán al atardecer',
  },
  {
    emoji: '🧶',
    aspecto: 'Cierre en Cancún',
    detalle:
      'Visita a la Virgen Desatadora de Nudos para entregar el nudo trabajado durante el retiro',
  },
]

export interface Facilitadora {
  nombre: string
  rol: string
  emoji: string
  cita: string
  parrafos: string[]
  lista?: { titulo: string; items: string[] }
  acento: string
}

export const FACILITADORAS: Facilitadora[] = [
  {
    nombre: 'María Desatanudos',
    rol: 'Nuestra anfitriona simbólica',
    emoji: '🧶',
    cita: 'No se trata necesariamente de olvidar. Se trata de aprender a soltar.',
    parrafos: [
      'María Desatanudos es la anfitriona de este viaje: la imagen que sostiene el hilo desde el primer día hasta el último. Desde el comienzo del encuentro, cada participante podrá identificar simbólicamente ese "nudo" que desea trabajar — una preocupación, un miedo, una situación, una etapa o simplemente algo que necesita entregar.',
      'Después de conectar con la tierra, el agua, el fuego, el aire, el sonido, la naturaleza y nosotros mismos, viajaremos a Cancún para visitarla y cerrar el viaje entregando ese nudo.',
    ],
    lista: {
      titulo: 'Los cuatro movimientos del cierre',
      items: ['Reconocer', 'Agradecer', 'Soltar', 'Confiar'],
    },
    acento: 'var(--glossygrape)',
  },
  {
    nombre: 'Paola Carvajal',
    rol: 'Tejedora de Conciencia',
    emoji: '🔮',
    cita: 'Te invito a descubrirte, a ser rebelde y a vivir plenamente en armonía con el propósito de tu alma y la guía de tu corazón.',
    parrafos: [
      'Tejedora de Conciencia. Entrelazo sabidurías ancestrales con poderosas herramientas contemporáneas. Te acompaño a conectar lo divino y lo terrenal, facilitando espacios sagrados donde la alquimia, la prosperidad, la salud y el amor se vuelven posibles para todos.',
      'Creadora de Espacio para el Alma y mamá de tres. Ha creado este contenedor con experiencia y amor: cada práctica tiene su propósito; cada pausa, su intención.',
    ],
    lista: {
      titulo: 'Trayectoria y certificaciones',
      items: [
        '📚 17.000 almas impactadas',
        '📖 1 libro publicado en Colombia y España',
        '🌍 22 viajes a centros energéticos del planeta',
        '🌀 Maestra en geometría sagrada y flor de la vida',
        '🌿 Sanadora pránica · Metafísica · Coach de vida',
      ],
    },
    acento: 'var(--satinsheengold)',
  },
]

export interface Precio {
  emoji: string
  concepto: string
  valor: string
}

export const PRECIOS: Precio[] = [
  { emoji: '🗓', concepto: 'Retiro completo', valor: '6 días / 5 noches' },
  { emoji: '💰', concepto: 'Valor embajadores', valor: '2.800 USD' },
  { emoji: '📌', concepto: 'Separación de cupo', valor: '444 USD' },
]
